import React from 'react';
import { OcrWordBox } from '../../utils/ocrSearchEngine';

interface OcrTextLayerOverlayProps {
  words?: OcrWordBox[];
  canvasWidth?: number;
  canvasHeight?: number;
}

export const OcrTextLayerOverlay: React.FC<OcrTextLayerOverlayProps> = ({
  words,
  canvasWidth,
  canvasHeight,
}) => {
  if (!words || words.length === 0 || !canvasWidth || !canvasHeight) {
    return null;
  }

  return (
    <div
      className="absolute inset-0 z-10 overflow-hidden pointer-events-auto leading-none select-text cursor-crosshair"
      style={{
        width: '100%',
        height: '100%',
      }}
      aria-hidden="true"
    >
      {words.map((w, idx) => {
        const left = (w.bbox.x0 / canvasWidth) * 100;
        const top = (w.bbox.y0 / canvasHeight) * 100;
        const width = Math.max(0.2, ((w.bbox.x1 - w.bbox.x0) / canvasWidth) * 100);
        const height = Math.max(0.5, ((w.bbox.y1 - w.bbox.y0) / canvasHeight) * 100);

        return (
          <span
            key={`ocr_word_${idx}`}
            style={{
              position: 'absolute',
              left: `${left}%`,
              top: `${top}%`,
              width: `${width}%`,
              height: `${height}%`,
              color: 'transparent',
              fontSize: `${height * 6}px`, // taille approximative proportionnelle
              transformOrigin: 'top left',
              display: 'inline-block',
              whiteSpace: 'pre',
            }}
            className="select-text cursor-crosshair"
          >
            {w.text}{' '}
          </span>
        );
      })}
    </div>
  );
};
